import React, {useState, useRef} from "react";

export default function ShippingMultiplierInput(props) {
    const {
        formik,
        stFormClass,
        inputType,
        labelName,
        isRequired,
        placeholder,
        formikFieldName,
        formikFieldIndex,
        noErrorMessage,
        disabled,

        addLabel,

        onChange = () => { },
        isDisabled
    } = props;

    // states
    const [inputFocus, setInputFocus] = useState(false)

    // refs
    const inputRef = useRef(null)

    // on focus
    const onInputFocus = ev => {
        setInputFocus(true)
    }

    // on blur
    const onInputBlur = ev => {
        setInputFocus(false)
    }

    return (
        <div className={`st-form-with-add-label ${stFormClass || ""} ${((formik?.touched?.allValues?.length && formik.touched.allValues[formikFieldIndex] && formik.touched.allValues[formikFieldIndex][formikFieldName]) && (formik?.errors?.allValues?.length && formik.errors.allValues[formikFieldIndex] && formik.errors.allValues[formikFieldIndex][formikFieldName])) ? "has-msg msg-error" : "" } ${isDisabled ? "disabled-elem" : ""}`}>
            {labelName ? (
                <label>
                    {labelName}
                    {isRequired && (
                        <span className="required ms-1 st-fs-12">
                            (required)
                        </span>
                    )}
                </label>
            ) : null}

            {/* main field */}
            <div className={`content-main d-flex ${inputFocus ? "focus" : ""}`} onClick={() => inputRef?.current?.focus()}>
                {
                    // additional label
                    addLabel ? (
                        <div className="add-label">
                            {addLabel}
                        </div>
                    ) : null
                }

                {/* input */}
                <input
                    type={inputType ?? "text"}
                    className="media-body"
                    placeholder={placeholder}
                    disabled={disabled}
                    ref={inputRef}
                    {...formik.getFieldProps(`allValues.${formikFieldIndex}.${formikFieldName}`)}
                    onChange={(e) => {
                        formik.handleChange(e)
                        onChange(e)
                    }}
                    onFocus={ev => {
                        onInputFocus(ev) // custom focus function
                    }}
                    onBlur={ev => {
                        onInputBlur(ev) // custom focus function
                        formik.handleBlur(ev)
                    }}
                    disabled={isDisabled}
                />
            </div>
            
            {
                /* form message */
                !noErrorMessage ? ((formik?.touched?.allValues?.length && formik.touched.allValues[formikFieldIndex] && formik.touched.allValues[formikFieldIndex][formikFieldName]) && (formik?.errors?.allValues?.length && formik.errors.allValues[formikFieldIndex] && formik.errors.allValues[formikFieldIndex][formikFieldName])) && (
                          <div className="st-form-msg">
                              <p className="st-fs-12">
                                {formik.errors.allValues[formikFieldIndex][formikFieldName]}
                              </p>
                          </div>
                      )
                    : null
            }
        </div>
    );
}